window.addEventListener('load', () => {
  const localizationForms = document.querySelectorAll('[data-localization_form]');
  if (!localizationForms || !localizationForms.length) return;
  localizationForms.forEach(initLocalizationForm);
});

function initLocalizationForm(form) {
  const valueList = form.querySelector('[data-value_list]');
  if (!valueList) return;
  const valueInput = form.querySelector(`input[name='${form.dataset.localization_form}_code']`);
  if (!valueInput) return;
  valueList.addEventListener('change', function (event) {
    valueInput.value = this.value;
    form.submit();
  });
}
